import { mapState } from 'vuex';

export default  {	
	data () {
		return { 
			active: 1

		}
	},
	created () { 
		this.searchGetIdb({tabla:'multiple_servicios', campo: 'lock', value: 'false'})
	},
	methods: {
			
		
		
	}
}
